import _implicitStylesheets from "./filterSection.css";
import _implicitScopedStylesheets from "./filterSection.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import _wdsPopoverTooltip from "wds/popoverTooltip";
import _wdsRadioGroup from "wds/radioGroup";
import _searchLocationFilter from "search/locationFilter";
import _searchLevel2FilterSection from "search/level2FilterSection";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<p type-style="display-8"${3}>${"t1"}</p>`;
const $fragment2 = parseFragment`<p type-style="display-8"${3}>${"t1"}</p>`;
const $fragment3 = parseFragment`<span class="tooltip-footer-text${0}"${2}>${"t1"}</span>`;
const stc0 = {
  "toggle-button": true
};
const stc1 = {
  "ariaHidden": "true",
  "symbol": "chevronup",
  "size": "small",
  "variant": "parent",
  "fill": "#747474"
};
const stc2 = {
  "tooltip-container": true
};
const stc3 = {
  "data-testid": "section-content",
  "grid": "",
  "axis": "column",
  "row-gap": "small"
};
const stc4 = {
  classMap: {
    "tooltip-footer-container": true
  },
  key: 13
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, b: api_bind, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, gid: api_scoped_id} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.sectionContainer),
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("div", {
    className: api_normalize_class_name($cmp.sectionTitleContainerClass),
    key: 1
  }, [$cmp.hasSectionToggle ? api_element("button", {
    classMap: stc0,
    attrs: {
      "data-section": $cmp.section.label,
      "data-testid": "section-toggle",
      "aria-label": $cmp.toggleLabel,
      "aria-expanded": $cmp.opened
    },
    key: 2,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleToggleSectionClick))
    }
  }, [api_custom_element("ads-icon", _adsIcon, {
    className: api_normalize_class_name($cmp.toggleClass),
    slotAssignment: "end",
    props: stc1,
    key: 3
  }), api_static_fragment($fragment1, 5, [api_static_part(1, null, api_dynamic_text($cmp.section.label))])]) : null, !$cmp.hasSectionToggle ? api_static_fragment($fragment2, 7, [api_static_part(1, null, api_dynamic_text($cmp.section.label))]) : null, $cmp.showTopTooltip ? api_custom_element("wds-popover-tooltip", _wdsPopoverTooltip, {
    classMap: stc2,
    props: {
      "popoverOrientation": $cmp.popoverOrientation,
      "tooltipData": $cmp.section.tooltip,
      "popoverLayout": "vertical"
    },
    key: 8
  }) : null]), api_element("div", {
    className: api_normalize_class_name($cmp.contentClass),
    attrs: stc3,
    key: 9
  }, [$cmp.isBaseType ? api_custom_element("wds-radio-group", _wdsRadioGroup, {
    attrs: {
      "data-testid": $cmp.section.key
    },
    props: {
      "id": api_scoped_id($cmp.section.key),
      "options": $cmp.section.options,
      "multiple": $cmp.section.multiple,
      "value": $cmp.section.selectedValue,
      "starsLabel": $cmp.starsLabels,
      "focusOnInitialize": $cmp.section.shouldFocusFirstElement,
      "enableRadioDeselect": $cmp.section.enableRadioDeselect
    },
    key: 10,
    on: {
      "change": _m2 || ($ctx._m2 = api_bind($cmp.handleOptionChange))
    }
  }) : null, $cmp.isLocationType ? api_custom_element("search-location-filter", _searchLocationFilter, {
    props: {
      "section": $cmp.section.name,
      "options": $cmp.section.options,
      "value": $cmp.section.selectedValue
    },
    key: 11
  }) : null, $cmp.isMultiLevelType ? api_custom_element("search-level2-filter-section", _searchLevel2FilterSection, {
    props: {
      "section": $cmp.section
    },
    key: 12
  }) : null]), $cmp.showBottomTooltip ? api_element("div", stc4, [api_static_fragment($fragment3, 15, [api_static_part(1, null, api_dynamic_text($cmp.tooltipLabel))]), api_custom_element("wds-popover-tooltip", _wdsPopoverTooltip, {
    classMap: stc2,
    props: {
      "popoverOrientation": $cmp.popoverOrientation,
      "tooltipData": $cmp.section.tooltip,
      "popoverLayout": "vertical"
    },
    key: 16
  })]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7rue2ug9avf";
tmpl.legacyStylesheetToken = "undefined-_filterSection";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
